import React from "react";

const clients = [
  "OIL & GAS \u2013 ONGC", "POWER \u2013 BHEL", "DEFENCE & STRATEGIC",
  "ATOMIC ENERGY", "INDIAN RAILWAYS", "STEEL & METALLURGY",
  "PHARMACEUTICALS", "TEXTILES & PAPER", "PETROCHEMICALS",
  "FERTILIZERS", "PULP & PAPER", "RESEARCH & LABS"
];

const TrustBar = () => {
  return (
    <section className="border-y border-slate-200 bg-white py-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-6">
        <div className="text-center mb-5">
          <span className="text-[12px] uppercase tracking-[0.22em] font-semibold text-slate-500">
            Approved supplier across India's Public Sector, Defence & Infrastructure
          </span>
        </div>
        <div className="relative overflow-hidden">
          <div className="flex gap-12 animate-marquee whitespace-nowrap">
            {[...clients, ...clients].map((c, i) => (
              <span key={i} className="font-display font-bold text-slate-400 text-[15px] tracking-[0.18em]">{c}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
